import styled, { keyframes } from "styled-components";
import { Row } from "antd";

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.12);
  }
  100% {
    transform: scale(1);
  }
`;

export const AskButton = styled(Row)`
  position: fixed;
  bottom: 80px;
  right: 16px;
  z-index: 1000;
  cursor: pointer;
  animation: ${pulse} 2s infinite ease-in-out;
`;